import {Cibles} from "./Cibles.js";

export class GestionnaireAlphabetPhonétique {
    constructor() {
        this.dialog = document.getElementById("alphabetPhonétiqueDialog");
        if (this.dialog) {
            this.initialiseClavier();
        }
    }

    initialiseClavier() {
        Object.values(document.getElementsByClassName("lettreAPI"))
            .forEach(lettreÉlément => lettreÉlément.addEventListener("click", this.toucheEnfoncée));
    }

    toucheEnfoncée(e) {
        let ruby = e.target.closest("ruby");
        let lettre = ruby.firstChild.textContent.trim();
        let input = document.getElementById('critèreValeurTexte');
        input.setRangeText(lettre, input.selectionStart, input.selectionEnd, 'end');
    }

    afficheOuMasqueClavierAPI(cible) {
        if (cible === Cibles.PRONONCIATION.code) {
            if (!this.dialog.open) {
                this.dialog.show();
            }
        } else {
            if (this.dialog.open) {
                this.dialog.close();
            }
        }
    }

    minimiseClavierAPI() {
        this.dialog.firstElementChild.removeAttribute('open');
    }
}
